<app-admin-nav />

<div class="stats-container">

  <div class="stats-header">
    <h1>Estadísticas de Búsqueda</h1>
    <div class="days-selector">
      <button [class.active]="selectedDays === 1" (click)="onDaysChange(1)">Hoy</button>
      <button [class.active]="selectedDays === 7" (click)="onDaysChange(7)">7 días</button>
      <button [class.active]="selectedDays === 14" (click)="onDaysChange(14)">14 días</button>
      <button [class.active]="selectedDays === 30" (click)="onDaysChange(30)">30 días</button>
    </div>
  </div>

  <!-- Loading -->
  @if (loading) {
    <div class="loading-state">
      <div class="spinner"></div>
      <p>Cargando estadísticas...</p>
    </div>
  }

  <!-- Error -->
  @if (!loading && error) {
    <div class="error-state">
      <p>Error al cargar las estadísticas.</p>
      <button (click)="loadStats()">Reintentar</button>
    </div>
  }

  <!-- Content -->
  @if (!loading && !error && stats) {

    <!-- KPI Cards -->
    <div class="kpi-grid">
      <div class="kpi-card">
        <span class="kpi-value">{{ stats.totalSearches }}</span>
        <span class="kpi-label">Búsquedas totales</span>
      </div>
      <div class="kpi-card highlight">
        <span class="kpi-value">{{ stats.dbHitRate }}%</span>
        <span class="kpi-label">Resueltas desde BD</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-value">{{ stats.googleCalls }}</span>
        <span class="kpi-label">Llamadas a Google</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-value">{{ stats.avgBarsFound }}</span>
        <span class="kpi-label">Media bares encontrados</span>
      </div>
    </div>

    <!-- Daily Trend -->
    <div class="chart-card">
      <h2>Búsquedas diarias</h2>

      <svg class="trend-svg" [attr.viewBox]="svgViewBox" preserveAspectRatio="none" aria-hidden="true">

        <!-- Horizontal grid lines -->
        @for (grid of trendGridLines(); track grid.y) {
          <line class="grid-line"
                x1="44" [attr.x2]="800 - 16"
                [attr.y1]="grid.y" [attr.y2]="grid.y" />
          <text class="grid-label" x="40" [attr.y]="grid.y + 4" text-anchor="end">
            {{ grid.label }}
          </text>
        }

        <!-- Area fills -->
        <path class="area-db"     [attr.d]="trendAreaPath('db')" />
        <path class="area-google" [attr.d]="trendAreaPath('google')" />

        <!-- Lines -->
        <path class="line-db"     [attr.d]="trendLinePath('db')"     fill="none" />
        <path class="line-google" [attr.d]="trendLinePath('google')" fill="none" />

        <!-- Dots (only when ≤7 days) -->
        @for (dot of trendDots('db'); track dot.cx) {
          <circle class="dot-db" [attr.cx]="dot.cx" [attr.cy]="dot.cy" r="4">
            <title>BD: {{ dot.value }}</title>
          </circle>
        }
        @for (dot of trendDots('google'); track dot.cx) {
          <circle class="dot-google" [attr.cx]="dot.cx" [attr.cy]="dot.cy" r="4">
            <title>Google: {{ dot.value }}</title>
          </circle>
        }

        <!-- X-axis labels -->
        @for (lbl of trendXLabels(); track lbl.x) {
          <text class="x-label" [attr.x]="lbl.x" y="196" text-anchor="middle">
            {{ lbl.label }}
          </text>
        }

      </svg>

      <div class="chart-legend">
        <span class="legend-dot db"></span> BD propia &nbsp;
        <span class="legend-dot google"></span> Google Places
      </div>
    </div>

    <!-- By Source + By Type -->
    <div class="charts-row">

      <div class="chart-card">
        <h2>Por fuente de resolución</h2>
        <div class="bar-list">
          @for (entry of objectEntries(stats.bySource); track entry[0]) {
            <div class="bar-row">
              <span class="bar-label">{{ sourceLabel(entry[0]) }}</span>
              <div class="bar-track">
                <div class="bar-fill"
                     [class.google]="entry[0] === 'GOOGLE_PLACES'"
                     [style.width]="getBarWidth(entry[1], getMaxValue(stats.bySource))">
                </div>
              </div>
              <span class="bar-count">{{ entry[1] }}</span>
            </div>
          }
        </div>
      </div>

      <div class="chart-card">
        <h2>Por tipo de búsqueda</h2>
        <div class="bar-list">
          @for (entry of objectEntries(stats.byQueryType); track entry[0]) {
            <div class="bar-row">
              <span class="bar-label">{{ typeLabel(entry[0]) }}</span>
              <div class="bar-track">
                <div class="bar-fill type"
                     [style.width]="getBarWidth(entry[1], getMaxValue(stats.byQueryType))">
                </div>
              </div>
              <span class="bar-count">{{ entry[1] }}</span>
            </div>
          }
        </div>
      </div>

    </div>

    <!-- By Category -->
    @if (objectEntries(stats.byCategory).length > 0) {
      <div class="chart-card">
        <h2>Por categoría detectada</h2>
        <div class="bar-list">
          @for (entry of objectEntries(stats.byCategory); track entry[0]) {
            <div class="bar-row">
              <span class="bar-label">{{ entry[0] }}</span>
              <div class="bar-track">
                <div class="bar-fill category"
                     [style.width]="getBarWidth(entry[1], getMaxValue(stats.byCategory))">
                </div>
              </div>
              <span class="bar-count">{{ entry[1] }}</span>
            </div>
          }
        </div>
      </div>
    }

  }

</div>
